import { render, staticRenderFns } from "./EditDirectory.vue?vue&type=template&id=4f665016&"
import script from "./EditDirectory.vue?vue&type=script&lang=js&"
export * from "./EditDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports